<template>
  <div>
    <el-dialog title="添加信息" :visible.sync="dialogVisible" width="800px">

      <el-form label-width="100px" :inline="true">
        <el-form-item label="流程Key">
          <el-input v-model="query.processKey" size="small" style="width: 200px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="流程名称">
          <el-input v-model="query.processName" size="small" style="width: 200px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button type="primary" plain @click="handleSearch" size="small">查询</el-button>
        </el-form-item>
      </el-form>


      <el-table :data="tableData" border>
        <el-table-column show-overflow-tooltip prop="id" label="id" v-if="isShow" width="100" header-align="center"
          align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="流程名称" width="350" header-align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="key" label="流程Key" width="300" header-align="center">
        </el-table-column>
        <el-table-column label="操作" width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="handleConfirm(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRows">
      </el-pagination>


    </el-dialog>
  </div>
</template>

<script>
  import axios from '@/axios';

  export default {
    data() {
      return {
 
        tableData: [],
        dialogVisible: false,
        post: {},

        isShow: false,
        query: {
          processKey:'',
          processName:''
        },

        popupType: '',
        currentPage: 1,
        totalRows: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
      };
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTableData()
      },
      handleSearch() {
        this.getTableData()
      },
      getTableData() {
        var url = 'activiti/ProcessModel/query.do'
        var start = (this.currentPage - 1) * this.pageSize
        var end = this.pageSize
        var param = {
          page: start,
          rows: end,
          processKey: this.query.processKey,
          processName: this.query.processName,
        }
        axios.get(url, param).then(response => {

          if (response.data.code == '0') {
            this.tableData = response.data.data.list
            this.totalRows = response.data.data.total
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }
        });
      },
   
      show() {
        this.getTableData()
        this.dialogVisible = true
      },
      handleConfirm(row) {
        this.$emit('receiveFromChild', row);
        this.dialogVisible = false
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/system/PopupProcess.vue